module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon message",
    class: _vm.isFooter ? 'footer-partner' : 'in-watchdog'
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        return _vm.$emit('dismiss')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "mini ui icon button",
    attrs: {
      "href": "https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit",
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isFooter ? 'Learn more' : '')), _c('i', {
    staticClass: "arrow right icon"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "width": "min(35vmin, 350px)",
      "line-height": "0"
    },
    attrs: {
      "href": "https://register.payoneer.com/en/solution/capital-advance/?p=sentrykit",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://d9hhrg4mnvzow.cloudfront.net/register.payoneer.com/en/solution/capital-advance/5f9c1dd5-payoneer-capital-advance-logo-dark-sml_1000000000000000000028.png",
      "alt": "banner"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Need cash to replenish stock?   SentryKit users get "), _c('strong', [_vm._v("10% fee rebate")]), _vm._v(" on their first Payoneer Capital Advance.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44b641d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerBanner.vue
// module id = 764
// module chunks = 2